export const industries = [
    {
        id: "beauty",
        preset: "BEAUTY",
        label: "Красота",
        icon: "scissors",
        short: "Салоны, барбершопы, мастера",
        title: "Запись открыта. Даже когда вы заняты.",
        description:
            "Клиент выбирает услугу, мастера и время. Вы видите расписание, историю визитов и загрузку команды в одной CRM.",
        seoTitle: "CRM для салона красоты: онлайн-запись, Mini App и сайт — TEZAM",
        steps: [
            "Клиент записывается на свободное время",
            "Мастер видит запись в своём расписании",
            "История визитов остаётся в базе клиентов",
        ],
        features: ["Услуги и прайс", "Расписание мастеров", "Клиентская база", "Бонусы и напоминания"],
        detail: "Салону важно видеть загрузку мастеров и повторные визиты. В TEZAM запись связана с услугой, клиентом и расписанием. Владелец управляет прайсом и командой, а клиент выбирает удобный слот в Mini App или на веб-витрине.",
        question: "Подойдёт ли TEZAM небольшому кабинету?",
        answer: "Да. Есть готовые ниши для ногтевого сервиса, бровей и ресниц, массажа и других услуг. Выберите свою нишу и замените демонстрационные услуги собственным прайсом. Лимиты сотрудников и услуг зависят от тарифа.",
        crm: "beauty-crm-records",
        app: "beauty-home",
        web: "beauty-site-home",
    },
    {
        id: "horeca",
        preset: "HORECA",
        label: "Кафе и рестораны",
        icon: "utensils",
        short: "Кафе, доставка, пекарни",
        title: "От выбора в меню — до заказа в работе.",
        description:
            "Меню, заказы и брони связаны с CRM. Гость выбирает в Telegram или на сайте, команда видит, что нужно сделать.",
        seoTitle: "CRM для кафе и ресторана: меню, заказы и Mini App — TEZAM",
        steps: [
            "Гость открывает меню или бронирует стол",
            "Заказ или бронь появляются в CRM",
            "Команда ведёт статусы и работу с гостем",
        ],
        features: ["Меню и модификаторы", "Залы и брони", "Доставка и самовывоз", "Техкарты и кухня по тарифу"],
        detail: "У кофейни и ресторана разные процессы. Ниша определяет начальное меню и набор возможностей: от витрины выпечки до бронирования столов и кухонного контура. Техкарты, KDS и оборудование подключаются с учётом тарифа и задач заведения.",
        question: "Подходит ли система для доставки?",
        answer: "В каталоге есть пиццерии, суши-бары, бургерные и другие заведения с заказом, доставкой или самовывозом. Условия доставки, меню и способы оплаты нужно настроить для вашего бизнеса. Специализированные интеграции согласуются отдельно.",
        crm: "horeca-crm-hall",
        app: "horeca-home",
        web: "horeca-site",
    },
    {
        id: "retail",
        preset: "RETAIL",
        label: "Магазины",
        icon: "bag",
        short: "Товары, цветы, шоурумы",
        title: "Витрина продаёт. CRM держит порядок.",
        description:
            "Один каталог для сайта и Telegram. Покупатель собирает корзину, а вы ведёте заказы и клиентов в общей системе.",
        seoTitle: "CRM и Telegram-магазин: каталог, заказы и сайт — TEZAM",
        steps: [
            "Покупатель выбирает товары в каталоге",
            "Оформляет доставку или самовывоз",
            "Вы обрабатываете заказ и сохраняете историю",
        ],
        features: ["Каталог и корзина", "Заказы и статусы", "Доставка и самовывоз", "Лояльность и склад по тарифу"],
        detail: "TEZAM подходит магазинам косметики, цветов, одежды, гаджетов и универсальным витринам. Товарный сценарий включает каталог, корзину и заказ. Запись к мастеру не перегружает интерфейс магазина. Склад и дополнительные инструменты доступны в соответствующих тарифах.",
        question: "Можно ли подключить свою учётную систему?",
        answer: "Возможность обмена с 1С, МойСклад или другой системой нужно проверить под вашу конфигурацию. Такие интеграции оцениваются отдельно; запуск готовой витрины не означает автоматическое подключение любой внешней системы.",
        crm: "ecom-crm-products",
        app: "ecom-home",
        web: "ecom-site-home",
    },
    {
        id: "fitness",
        preset: "FITNESS",
        label: "Фитнес",
        icon: "activity",
        short: "Залы, студии, занятия",
        title: "Расписание, к которому легко присоединиться.",
        description:
            "Занятия, тренеры и абонементы в одной системе. Клиент выбирает тренировку, команда работает с записью и посещениями.",
        seoTitle: "CRM для фитнес-клуба и студии: запись и абонементы — TEZAM",
        steps: [
            "Клиент выбирает занятие или тренера",
            "Записывается на подходящий слот",
            "Администратор ведёт расписание и абонементы",
        ],
        features: ["Групповые занятия", "Персональные тренировки", "Абонементы", "СКУД по тарифу и оборудованию"],
        detail: "Готовые ниши охватывают фитнес-залы, йогу, танцы, бассейны и конные клубы. Расписание и слоты помогают организовать запись. Контроль доступа требует совместимого оборудования и соответствующего тарифа: его подключение проверяется отдельно.",
        question: "Можно ли организовать групповые занятия?",
        answer: "Да, групповые занятия и работа с ресурсами предусмотрены в контуре Booking 2.0. Доступность зависит от тарифа. Перед запуском настройте тренеров, расписание и вместимость занятий.",
        crm: "fitness-crm-services",
        app: "fitness-home",
        web: "fitness-site-home",
    },
    {
        id: "services",
        preset: "SERVICES",
        label: "Услуги",
        icon: "wrench",
        short: "Сервис, обучение, клининг",
        title: "Каждой заявке — понятный следующий шаг.",
        description:
            "Клиент выбирает услугу и оставляет заявку. Сотрудники видят записи и статусы, а история работы остаётся у бизнеса.",
        seoTitle: "CRM для услуг: заявки, сотрудники и онлайн-запись — TEZAM",
        steps: [
            "Клиент выбирает услугу или пакет",
            "Оставляет заявку или записывается",
            "Сотрудник ведёт работу и меняет статус",
        ],
        features: ["Каталог услуг", "Запись и заявки", "Специалисты", "Статусы и история"],
        detail: "Для ремонта важны заявки и статусы, для студии — бронирование времени, для клининга — выездные пакеты. TEZAM предлагает отдельные ниши для этих сценариев, а также для детских центров, обучения и услуг для питомцев.",
        question: "Подойдёт ли TEZAM выездной услуге?",
        answer: "Для клининга и сервисных компаний предусмотрены заявки и услуги. Нужный процесс выезда проверяется при настройке. Диспетчеризация транспортного парка и планирование логистических рейсов не входят в стандартный сценарий.",
        crm: "service-crm-specialists",
        app: "service-home",
        web: "service-site-home",
    },
    {
        id: "realty",
        preset: "REALTY",
        label: "Недвижимость",
        icon: "home",
        short: "Объекты, агентства, аренда",
        title: "Объекты на витрине. Обращения в CRM.",
        description:
            "Публикуйте объекты, собирайте заявки на просмотр или управляйте арендой по датам — в зависимости от вашей ниши.",
        seoTitle: "CRM для недвижимости: витрина объектов, заявки и аренда — TEZAM",
        steps: [
            "Клиент находит подходящий объект",
            "Оставляет заявку или выбирает даты аренды",
            "Команда обрабатывает обращение в CRM",
        ],
        features: ["Карточки объектов", "Заявки и лиды", "Показы по записи", "Календарь аренды"],
        detail: "Для недвижимости предусмотрены три сценария: витрина объектов, посуточная аренда и агентство с записью на показы или консультации. В арендной нише используются отдельные юниты с календарём занятости. Интеграции с внешними агрегаторами обсуждаются отдельно.",
        question: "Можно ли вести посуточную аренду?",
        answer: "Для этого есть отдельная ниша «Аренда жилья»: объекты и юниты с календарём занятости. Это собственная витрина одного бизнеса; подключение Booking и других внешних площадок не входит в базовый запуск.",
    },
    {
        id: "auto-sales",
        preset: "AUTO_SALES",
        label: "Автобизнес",
        icon: "car",
        short: "Автосалоны, запчасти, прокат",
        title: "От интереса к автомобилю — к заявке.",
        description:
            "Витрина автомобилей, продажа запчастей или аренда по датам. Выберите сценарий бизнеса и работайте с обращениями в CRM.",
        seoTitle: "CRM для автосалона и проката: каталог и заявки — TEZAM",
        steps: [
            "Клиент выбирает автомобиль или товар",
            "Оставляет заявку, заказ или бронь",
            "Менеджер продолжает работу в CRM",
        ],
        features: ["Каталог автомобилей", "Заявки и тест-драйвы", "Запчасти и заказы", "Прокат по датам"],
        detail: "Продажа автомобиля, магазин запчастей и прокат используют разные сценарии. В каталоге ниш они разделены: витрина с заявками, каталог со складом, аренда по датам и автосалон с записью на тест-драйв. Полный TecDoc и VIN-каталог требуют отдельного решения.",
        question: "Подойдёт ли система одновременно для продаж и СТО?",
        answer: "Продажа и обслуживание представлены разными направлениями. Для СТО предусмотрена отдельная ниша с записью и заказ-нарядами. Совместный процесс продаж и ремонта нужно согласовать перед внедрением.",
    },
    {
        id: "auto-service",
        preset: "AUTO_SERVICE",
        label: "Автосервис",
        icon: "wrench",
        short: "СТО, диагностика, ремонт",
        title: "От записи на ремонт — до статуса работ.",
        description:
            "Принимайте заявки, ведите запись и заказ-наряды. Информация по клиенту и работе находится в одном рабочем пространстве.",
        seoTitle: "CRM для автосервиса: запись, заказ-наряды и Mini App — TEZAM",
        steps: [
            "Клиент выбирает услугу и время",
            "Сотрудник принимает заявку в работу",
            "Заказ-наряд и статус сохраняются в системе",
        ],
        features: ["Запись на диагностику", "Заказ-наряды", "Статусы работ", "Расходники"],
        detail: "Контур автосервиса объединяет сервисную запись, заказ-наряды, статусы и расходники. Клиентская витрина помогает начать обращение, CRM — провести его через работу. Состав OEM-данных и интеграции нужно проверить под задачи конкретной СТО.",
        question: "Есть ли полный подбор запчастей по VIN?",
        answer: "Полный VIN-подбор и TecDoc не входят в стандартный запуск. Если это ключевой процесс вашей СТО, его стоит отдельно обсудить до перехода на систему.",
    },
] as const;

export type Industry = (typeof industries)[number];
export type IndustryId = Industry["id"];
export function findIndustry(id?: string | null): Industry | undefined {
    const aliases: Record<string, string> = { ecom: "retail", ecommerce: "retail", service: "services" };
    return industries.find((item) => item.id === (aliases[id ?? ""] ?? id));
}
